@if (!isLoaded) {
  <div>
    Loading report...
  </div>
}
@if (isLoaded && reportTarget) {
  <div>
    @for (question of reportQuestions; track question) {
      <div>
        <div id="editor" [froalaEditor]="toolbarOptions" (keyup)="onKeyUp(question[0])"
        [(froalaModel)]="question[0].label"></div>
      </div>
    }
  </div>
}
@if (isLoaded && !reportTarget) {
  <div class="red">
    Report source not configured
  </div>
}